module.exports = __webpack_public_path__ + "static/img/ts_case_pic3.a6054ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ts_case_pic3.jpg
// module id = fKIW
// module chunks = 1